import React, {useMemo} from 'react';
import {getRandomDashboardHeroImage} from "../helpers/dashboardHeroImages";
import './data-onboarding.scss';

export type LoadingDataProps = {
    title?: string,
    message?: string
}

const loadingMessages = [
    'Listening for chip notes...',
    'Flipping through the field guide...',
    'Scoping the horizon...',
    'Asking Merlin for a second opinion...',
    'Reviewing field marks...',
    'Untangling taxonomic revisions...',
    'Applying bug spray...'
];

export default function LoadingData({
    title = 'Loading your data...',
    message
}: LoadingDataProps) {
    const onboardingHeroImage = useMemo(() => getRandomDashboardHeroImage(), []);
    const loadingMessage = useMemo(() => {
        return loadingMessages[Math.floor(Math.random() * loadingMessages.length)];
    }, []);

    return (
        <section className="data-onboarding data-onboarding--loading" aria-live="polite" aria-busy="true">
            <div className="data-onboarding__content">
                <div className="data-onboarding__loading-spinner" aria-hidden="true" />
                <h1 className="data-onboarding__headline">{title}</h1>
                <div className="data-onboarding__copy">
                    <p>{message ?? loadingMessage}</p>
                </div>
            </div>
            <aside
                className="data-onboarding__hero"
                aria-label="Bird in a natural habitat"
                style={{'--data-onboarding-hero-image': `url("${onboardingHeroImage}")`} as React.CSSProperties}
            />
        </section>
    )
}
